import http from '@/common/http';
import constants from '@/config/constants';
import { isEmpty } from '@/common/validators';
import store from '../index';
import { checkSenarioBStep } from '@/common/chatUtils';

const initialState = {
  clid: null,
  startStep: null,
  currentStep: null,
  nextStep: null,
  inputType: null,
  prevInputType: null,
  text: null,
  select: null,
  choice: null,
  messages: null,
  modal: null,
  isTermsAgree: false,
  isPrivacyPolicyAgree: false,
  requestNextStep: '',
  mode: null,
  callApi: null,
  showLlmPopup: false
};

export default {
  namespaced: true,
  state: {
    clid: null,
    startStep: null,
    currentStep: null,
    nextStep: null,
    inputType: null,
    prevInputType: null,
    text: null,
    select: null,
    choice: null,
    messages: null,
    modal: null,
    isTermsAgree: false,
    isPrivacyPolicyAgree: false,
    requestNextStep: '',
    mode: null,
    callApi: null,
    showLlmPopup: false
  },
  getters: {
    clid(state) {
      return state.clid;
    },
    startStep(state) {
      return state.startStep;
    },
    currentStep(state) {
      return state.currentStep;
    },
    nextStep(state) {
      return state.nextStep;
    },
    inputType(state) {
      return state.inputType;
    },
    prevInputType(state) {
      return state.prevInputType;
    },
    text(state) {
      return state.text;
    },
    select(state) {
      return state.select;
    },
    choice(state) {
      return state.choice;
    },
    messages(state) {
      return state.messages;
    },
    modal(state) {
      return state.modal;
    },
    isTermsAgree(state) {
      return state.isTermsAgree;
    },
    isPrivacyPolicyAgree(state) {
      return state.isPrivacyPolicyAgree;
    },
    mode(state) {
      return state.mode;
    },
    callApi(state) {
      return state.callApi;
    },
    showLlmPopup(state) {
      return state.showLlmPopup;
    }
  },
  actions: {
    /**
     * 相談チャット応答処理
     * @param reqData リクエストデータ
     */
    async request({ rootState, commit, state }, reqData) {
      if (state.requestNextStep == reqData.nextStep) return;
      commit('setRequestNextStep', reqData.nextStep);
      return new Promise((resolve, reject) => {
        let ageToStoring = null;
        let birthYearToStoring = null;
        if (!isEmpty(reqData.age)) {
          ageToStoring = reqData.age.toString();
        }
        if (!isEmpty(rootState.user.birth_year)) {
          birthYearToStoring = rootState.user.birth_year.toString();
        }
        let params = {
          u_id: rootState.user.user_id,
          nickname: rootState.user.nickname,
          birth_year: birthYearToStoring,
          age: ageToStoring,
          age_range: reqData.ageRange,
          gender: rootState.user.gender,
          current_step: reqData.currentStep,
          next_step: reqData.nextStep,
          mode: state.mode,
          input_type: state.inputType,
          job: rootState.user.job,
          call_api: state.call_api,
          NoLoginAccess: true
        };
        if (!isEmpty(state.clid)) {
          params['cl_id'] = state.clid;
        }
        if (!isEmpty(reqData.input)) {
          params['input'] = reqData.input;
        }
        if (!isEmpty(reqData.message)) {
          params['message'] = reqData.message;
        }
        if (!isEmpty(rootState.user.tags)) {
          params['tags'] = rootState.user.tags;
        }
        if (!isEmpty(state.modal) && !isEmpty(state.modal.type)) {
          params['modal_type'] = state.modal.type;
        }
        if (!isEmpty(state.text) && !isEmpty(state.text.var)) {
          params['input_var'] = state.text.var;
        } else if (!isEmpty(state.select) && !isEmpty(state.select.var)) {
          params['input_var'] = state.select.var;
        } else if (!isEmpty(state.choice) && !isEmpty(state.choice.var)) {
          params['input_var'] = state.choice.var;
        }
        if (!isEmpty(rootState.user.tenant_id)) {
          params['tenant_id'] = rootState.user.tenant_id;
        }
        if (!isEmpty(rootState.user.tenant_code)) {
          params['tenant_code'] = rootState.user.tenant_code;
        }
        if (!isEmpty(rootState.user.residence)) {
          params['residence'] = rootState.user.residence;
        }
        if (!isEmpty(rootState.user.job_type)) {
          params['job_type'] = rootState.user.job_type;
        }

        if (state.call_api && state.call_api.length > 0 && state.call_api.includes('llm')) {
          // タグ情報から
          let summaries = store.getters['eqChatLog/summaries'];
          // LLM用APIパラメータを追加
          if (Object.prototype.hasOwnProperty.call(summaries, '<EVENT>')) {
            params['llm_event'] = summaries['<EVENT>'];
          }
          if (Object.prototype.hasOwnProperty.call(summaries, '<FEEL>')) {
            params['llm_feel'] = summaries['<FEEL>'];
          }
          if (Object.prototype.hasOwnProperty.call(summaries, '<FACT>')) {
            params['llm_fact'] = summaries['<FACT>'];
          }
          if (Object.prototype.hasOwnProperty.call(summaries, '<POSITIVE>')) {
            params['llm_positive'] = summaries['<POSITIVE>'];
          }
          if (Object.prototype.hasOwnProperty.call(summaries, '<ADVICE>')) {
            params['llm_advice'] = summaries['<ADVICE>'];
          }
          if (Object.prototype.hasOwnProperty.call(summaries, '<CHALLENGE>')) {
            params['llm_challenge'] = summaries['<CHALLENGE>'];
          }
        }

        http
          .post(constants.API_EQCHAT_URI, params)
          .then(response => {
            if (response) {
              commit('success', response.data);
              commit('setNextStep', response.data.next_step);
              commit('setCallApi', response.data.call_api);

              // LLMポップアップの表示フラグがある場合、ストアに保持する
              if (response.data.show_llm_popup != null && response.data.show_llm_popup != undefined) {
                commit('setShowLlmPopup', response.data.show_llm_popup);
              }
            }
            resolve();
          })
          .catch(error => {
            reject(error);
          });

        if (constants.LLM_LOG_POST_STEP_LIST.includes(reqData.nextStep)) {
          // LLMダイアログ保持情報
          const llmExampleModals = store.getters['eqChatComponent/llmExampleModals'];

          // シナリオ（step_EQ_721またはstep_EQ_B_721）に合致するLLMモーダルを取得する
          let llmExampleModal = llmExampleModals.find(obj => constants.LLM_MODAL_STEP_LIST.includes(obj.step));

          // 次シナリオがstep_EQ_723かつstep_EQ_721、またはstep_EQ_B_723かつstep_EQ_B_721でLLMモーダルが取得できた場合、LLMログを登録
          if (llmExampleModal) {
            // パラメータ設定
            // 基本情報
            let paramLLm = {};
            paramLLm['NoLoginAccess'] = true;
            paramLLm['cl_id'] = params['cl_id'];

            // LLM用API入力パラメータを追加
            let summaries = store.getters['eqChatLog/summaries'];
            if (Object.prototype.hasOwnProperty.call(summaries, '<EVENT>')) {
              paramLLm['input_event'] = summaries['<EVENT>'];
            }
            if (Object.prototype.hasOwnProperty.call(summaries, '<FEEL>')) {
              paramLLm['input_feel'] = summaries['<FEEL>'];
            }
            if (Object.prototype.hasOwnProperty.call(summaries, '<FACT>')) {
              paramLLm['input_fact'] = summaries['<FACT>'];
            }
            if (Object.prototype.hasOwnProperty.call(summaries, '<POSITIVE>')) {
              paramLLm['input_positive'] = summaries['<POSITIVE>'];
            }
            if (Object.prototype.hasOwnProperty.call(summaries, '<ADVICE>')) {
              paramLLm['input_advice'] = summaries['<ADVICE>'];
            }
            if (Object.prototype.hasOwnProperty.call(summaries, '<CHALLENGE>')) {
              paramLLm['input_challenge'] = summaries['<CHALLENGE>'];
            }

            // LLM出力結果をパラメータに追加
            const isView = llmExampleModal.isView;
            const llmModal = llmExampleModal.modal;
            const llmOutput = [];

            for (let i = 0; i < llmModal.example.length; i++) {
              const no = i + 1;
              let columnNo = String(no).padStart(2, 0);

              paramLLm['solution_' + columnNo] = llmModal.example[i].solution;
              paramLLm['detail_' + columnNo] = llmModal.example[i].detail;
              // 評価内容を編集
              if (Object.prototype.hasOwnProperty.call(llmModal.example[i], 'userReview')) {
                paramLLm['user_review_' + columnNo] = llmModal.example[i].userReview;
              } else {
                paramLLm['user_review_' + columnNo] = isView ? 'see' : 'unread';
              }
              // LLM出力結果を保持
              llmOutput.push('title' + no + ':' + llmModal.example[i].solution);
              llmOutput.push('detail' + no + ':' + llmModal.example[i].detail);
            }
            paramLLm['llm_output'] = llmOutput.join(',');

            // LLMLOG登録
            http.post(constants.API_LLMLOG_URI, paramLLm).catch(() => {
              // エラー画面に遷移
              this.$router.push({ name: 'Error' });
            });
          }
        }
      });
    },
    /**
     * Stateを初期化
     */
    destoryState({ commit }) {
      commit('destoryState');
    },
    /**
     * 次ステップ番号の設定
     */
    setNextStep({ commit }, nextStep) {
      commit('setNextStep', nextStep);
    },
    setPrevInputType({ commit }, inputType) {
      commit('setPrevInputType', inputType);
    },
    /**
     * モードの設定
     */
    setMode({ commit }, mode) {
      commit('setMode', mode);
    },
    /**
     * テキスト入力時の属性の設定
     */
    setInputTextVar({ commit }, textVar) {
      commit('setInputTextVar', textVar);
    }
  },
  mutations: {
    success(state, results) {
      if (isEmpty(results)) {
        return;
      }
      state.clid = results.cl_id;
      state.currentStep = results.current_step;
      state.inputType = results.input_type;
      state.text = results.text;
      state.select = results.select;
      state.choice = results.choice;
      state.messages = results.messages;
      state.modal = results.modal;
    },
    destoryState(state) {
      for (let key in state) {
        if (Object.prototype.hasOwnProperty.call(initialState, key)) {
          state[key] = initialState[key];
        }
      }
    },
    setStartStep(state, startStep) {
      state.startStep = startStep;
    },
    setNextStep(state, nextStep) {
      if (!Array.isArray(nextStep)) {
        state.nextStep = '';
        return;
      }

      // Eqシナリオステップ番号の正規表現
      const eQstepRegexp = new RegExp(
        '^' + constants.STEP_FIRST_CHAR + constants.STEP_CONNECT_CHAR + constants.STEP_INTRO_EQ_CHAR + constants.STEP_CONNECT_CHAR + '[0-9]{3}'
      );

      // EQイントロシナリオステップ番号の正規表現
      const introEqStepRegexp = new RegExp(
        '^' +
          constants.STEP_FIRST_CHAR +
          constants.STEP_CONNECT_CHAR +
          constants.STEP_INTRO_CHAR +
          constants.STEP_CONNECT_CHAR +
          constants.STEP_INTRO_EQ_CHAR +
          constants.STEP_CONNECT_CHAR +
          '[0-9]{3}'
      );

      // 次ステップ番号の先頭がEQシナリオステップ番号の場合
      if (!isEmpty(nextStep[0].match(eQstepRegexp))) {
        state.nextStep = nextStep[0];
        return;
      }

      // 次ステップ番号の先頭がEQイントロシナリオステップ番号の場合
      if (!isEmpty(nextStep[0].match(introEqStepRegexp))) {
        state.nextStep = nextStep[0];
        return;
      }

      // 次ステップ番号がシナリオBのシナリオステップ番号またはイントロシナリオステップ番号の場合
      if (checkSenarioBStep(nextStep[0])) {
        state.nextStep = nextStep[0];
        return;
      }

      // タグ専用シナリオステップ番号の中に一致するタグが存在しない場合
      let lastNextStep = nextStep[nextStep.length - 1];
      // 次ステップ番号の最終シナリオステップ番号がEQシナリオの場合
      if (lastNextStep.match(eQstepRegexp)) {
        state.nextStep = lastNextStep;
      } else if (lastNextStep.match(introEqStepRegexp)) {
        // 次ステップ番号の最終シナリオステップ番号がEQイントロシナリオの場合
        state.nextStep = lastNextStep;
      } else if (checkSenarioBStep(lastNextStep)) {
        // 次ステップ番号の最終シナリオステップ番号がシナリオBの場合
        state.nextStep = lastNextStep;
      } else if (Object.values(constants.RESERVED_STEP).includes(lastNextStep)) {
        // 次ステップ番号の最終が予約ステップ番号の場合
        state.nextStep = lastNextStep;
      } else {
        // 次ステップ番号の最終が通常シナリオ以外の場合
        state.nextStep = '';
      }
    },
    setTermsAgree(state, isTermsAgree) {
      state.isTermsAgree = isTermsAgree;
    },
    setPrivacyPolicyAgree(state, isPrivacyPolicyAgree) {
      state.isPrivacyPolicyAgree = isPrivacyPolicyAgree;
    },
    setRequestNextStep(state, nextStep) {
      state.requestNextStep = nextStep;
    },
    setMode(state, mode) {
      state.mode = mode;
    },
    setInputTextVar(state, textVar) {
      state.text.var = textVar;
    },
    setCallApi(state, callApi) {
      state.call_api = callApi;
    },
    setPrevInputType(state, inputType) {
      state.prevInputType = inputType;
    },
    setShowLlmPopup(state, showLlmPopup) {
      state.showLlmPopup = showLlmPopup;
    }
  }
};
